import { render, staticRenderFns } from "./_base-nav.vue?vue&type=template&id=3f1b0454&scoped=true&"
import script from "./_base-nav.vue?vue&type=script&lang=js&"
export * from "./_base-nav.vue?vue&type=script&lang=js&"
import style0 from "./_base-nav.vue?vue&type=style&index=0&id=3f1b0454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b0454",
  null
  
)

export default component.exports